export default __webpack_public_path__ + "static/media/card_2_paseo.967589f1.jpg";